import * as React from "react";
import { CourseInstructionPartOperations } from "ts/components/course-author/instruction/parts/CourseInstructionPart.types";
import { courseInstructionPartViews } from "../../../../../../../utils/courseViews";
import { PreferredLocale } from "../../../../../../../utils/locales";
import { Choices } from "../../../../../../course-author/instruction/parts/exercises/choice/Choices.container";
import { ExerciseWrapper } from "../../../../../../course-author/instruction/parts/exercises/ExerciseWrapper";
import { IChoiceExercise } from "../../../../../../course-author/types";

export interface IChoiceExercisePartProps {
  choiceExercisePart: IChoiceExercise;
  currentLocale: PreferredLocale;
  edit: boolean;
  partOperations: CourseInstructionPartOperations;
}

export const ChoiceExercisePart: React.FC<IChoiceExercisePartProps> = props => {
  const { currentLocale, choiceExercisePart, partOperations } = props;
  const choices = courseInstructionPartViews.choiceExercisePart.items(choiceExercisePart);
  const randomizeQuestionsCheckbox = `randomize-${choiceExercisePart.id}`;
  const toggleRandomize = () => props.edit && props.partOperations.modifyChoiceExerciseRandom();

  return (
    <ExerciseWrapper
      currentLocale={currentLocale}
      edit={props.edit}
      exercisePart={choiceExercisePart}
      partOperations={partOperations}
    >
      <Choices
        enableEdit={props.edit}
        operations={partOperations}
        toggleRandomize={toggleRandomize}
        currentLocale={currentLocale}
        exercise={choiceExercisePart}
        randomize={choiceExercisePart.content.randomize}
        choices={choices}
        randomizeQuestionsCheckbox={randomizeQuestionsCheckbox}
      />
    </ExerciseWrapper>
  );
};
